import axios from "axios";
import jquery from 'jquery';
window.jQuery = window.$ = jquery;

$(function () {
    ViewItemList();
});

//#region View Item List
function ViewItemList() {

    console.log('datalayer view_item_list');

    var maxElementViewItemList = 12;
    var nameViewItemList = $("[id*=DataLayerViewItemListPath]").val();

    var items = GetItemsViewItemList();

    if (items && items.length > 0)
    {
        //console.log('DEBUG: ' + JSON.stringify(items))
        var pageNumber = Math.ceil(items.length / maxElementViewItemList);
        for (var i = 1; i <= pageNumber; i++)
        {
            var pagedItems = items.slice(((i - 1) * maxElementViewItemList), (i * maxElementViewItemList));
            //console.log(pagedItems)

            axios({
                method: 'get',
                url: `${window.baseurl}/api/DataLayer/ViewItemList?IDs=${pagedItems.join(',')}&culture=${window.culture}&name=${nameViewItemList}`
            })
            .then(response => {
                var viewDataLayer = response.data;
                if (viewDataLayer) {
                    dataLayer.push({
                        event: "view_item_list",
                        ecommerce: {
                            items: viewDataLayer.items
                        }
                    });
                }
            })
            .catch(error => {
                console.log('error:' + error);
            })
        }
    }
}
//#endregion

function GetItemsViewItemList() {

    var items = [];
    var viewItemListEl = $("[id=ViewItemList]");
    if (viewItemListEl) {
        for (var q = 0; q < viewItemListEl.length; q++) {
            var childrens = $(viewItemListEl[q]).children();
            if (childrens) {
                for (var i = 0; i < childrens.length; i++) {
                    var id = $(childrens[i]).data("id");
                    if (id) {
                        items.push(id);
                    }
                }
            }
        }
    }

    return items;
}